<div
  class="sui-date-picker"
  [class.sui-date-picker--inline]="inline"
  ngpDatePicker
  [ngpDatePickerDate]="primitiveDate()"
  [ngpDatePickerMin]="minDate"
  [ngpDatePickerMax]="maxDate"
  [ngpDatePickerDisabled]="isDisabled()"
  [ngpDatePickerDateDisabled]="dateDisabled"
  [ngpDatePickerFirstDayOfWeek]="firstDayOfWeek"
  (ngpDatePickerDateChange)="onDateChange($event)"
  (ngpDatePickerFocusedDateChange)="onFocusedDateChange($event)"
>
  @if (inline) {
    <ng-container
      *ngTemplateOutlet="calendarBody; context: { $implicit: popoverContainer }"
    />
  } @else {
    <!-- Field: formatted/parse-on-type input + calendar-icon trigger. The trigger
         lives in the input's suffix slot, but the popover anchors to the whole
         field via [suiPopoverAnchor]. -->
    <div class="sui-date-picker__field" #fieldEl>
      <sui-input
        class="sui-date-picker__field-input"
        [id]="effectiveId"
        [placeholder]="placeholder"
        [disabled]="isDisabled()"
        [ngModel]="inputText()"
        [ngModelOptions]="{ standalone: true }"
        [invalid]="inputInvalid()"
        (ngModelChange)="onInputText($event)"
        (keydown.enter)="onInputEnter()"
        (focusin)="onInputFocus()"
        (focusout)="onInputBlur()"
      >
        <button
          sui-suffix
          type="button"
          class="sui-date-picker__trigger"
          aria-label="Open calendar"
          [suiPopoverTrigger]="calendarTpl"
          [suiPopoverAnchor]="fieldEl"
          [suiPopoverContainer]="resolvedPopoverContainer"
          [suiPopoverTriggerDisabled]="isDisabled()"
        >
          <fa-icon [icon]="faCalendar" />
        </button>
      </sui-input>
    </div>

    <ng-template #calendarTpl>
      <div suiPopover class="sui-date-picker__panel" #panelEl>
        <button
          type="button"
          class="sui-date-picker__close"
          aria-label="Close calendar"
          (click)="closePopover()"
        >
          <fa-icon [icon]="faClose" />
        </button>
        <ng-container
          *ngTemplateOutlet="calendarBody; context: { $implicit: panelEl }"
        />
      </div>
    </ng-template>
  }

  <!-- Shared header + calendar grid. Declared inside [ngpDatePicker] so the
       popover-portaled copy still resolves the primitive's state at this
       declaration site. The context value is the container the month/year select
       dropdowns portal into — the popover panel in field mode (so their dropdown
       isn't an "outside click" that closes the popover), else popoverContainer. -->
  <ng-template #calendarBody let-selectContainer>
    <div class="sui-date-picker__header">
      <button
        type="button"
        class="sui-date-picker__nav"
        ngpDatePickerPreviousMonth
        aria-label="Previous month"
      >
        <fa-icon [icon]="faPrev" />
      </button>

      <!-- Quick-nav: month + year selects (ngb navigation-select equivalent). -->
      <div class="sui-date-picker__nav-selects">
        <sui-select
          class="sui-date-picker__month-select"
          aria-label="Month"
          [disabled]="isDisabled()"
          [dropdownContainer]="selectContainer"
          [ngModel]="focusedMonth()"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onMonthChange($event)"
        >
          @for (m of monthOptions(); track m.value) {
            <sui-select-option
              [value]="m.value"
              [label]="m.label"
              [disabled]="m.disabled"
              >{{ m.label }}</sui-select-option
            >
          }
        </sui-select>

        <sui-select
          class="sui-date-picker__year-select"
          aria-label="Year"
          [disabled]="isDisabled()"
          [dropdownContainer]="selectContainer"
          [ngModel]="focusedYear()"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onYearChange($event)"
        >
          @for (y of years(); track y) {
            <sui-select-option [value]="y" [label]="y.toString()">{{
              y
            }}</sui-select-option>
          }
        </sui-select>
      </div>

      <!-- Live-region for month-change announcements; visually hidden. The grid's
           accessible name comes from [ariaLabel] on <sui-calendar> (robust across
           the popover boundary). -->
      <span class="sui-date-picker__sr-label" ngpDatePickerLabel>{{
        label()
      }}</span>

      <button
        type="button"
        class="sui-date-picker__nav"
        ngpDatePickerNextMonth
        aria-label="Next month"
      >
        <fa-icon [icon]="faNext" />
      </button>
    </div>

    <sui-calendar [showWeekNumbers]="showWeekNumbers" [ariaLabel]="label()" />
  </ng-template>
</div>
